// The marked Lexer that is lexing a document right now (set by markdown.ts).
//
// The `inlineTokens` helper `@tiptap/markdown` hands to tokenizers resolves the
// inline content on the spot. marked itself resolves inline content at the end
// of lexing (its inline queue), so a reference link definition further down
// (`[spec]: http://...`) already counts when `[spec]` is resolved. Resolving on
// the spot misses definitions not read yet. Task list items (task-list.ts)
// re-lex their text themselves, so they go through the queue here instead.

import type { Lexer, Token } from "marked";

let active: Lexer | null = null;

/** Makes `lexer` the current one while `run` runs (restored when nested). */
export function withActiveLexer<T>(lexer: Lexer, run: () => T): T {
  const previous = active;
  active = lexer;
  try {
    return run();
  } finally {
    active = previous;
  }
}

/**
 * Queues `src` to be lexed inline at the end of lexing (the returned array is
 * filled then). Undefined when no lexer is current (the caller lexes on the spot).
 */
export function inlineLater(src: string): Token[] | undefined {
  return active?.inline(src, []);
}
